import { Box, Stack, Typography, Chip, Collapse, Divider } from '@mui/material'
import React, { useState } from 'react'
import { Stock } from '../../../../interfaces'
import { formatExpirationDate } from '../../../../utils/dateHelper'
import { skuCardStyles as s } from '../Styles/StockByPositionResults.styles'
import { getStyleRow, mapBatchStatusToExpiredColor } from '../../../../utils/colors'

export const SkuCard: React.FC<{ item: Stock }> = ({ item }) => {
  const [expanded, setExpanded] = useState(false)
  const hasBatches = item.details?.length > 0

  return (
    <Box sx={s.card}>
      {/* SKU header row */}
      <Stack
        direction='row'
        alignItems='flex-start'
        justifyContent='space-between'
        sx={{ p: 0.75 }}
      >
        <Stack spacing={0.5}>
          <Stack direction='row' alignItems='center' spacing={0.5}>
            <Typography sx={{ ...s.skuCode, fontSize: '0.85rem' }}>{item.stockKeepingUnit}</Typography>
          </Stack>
          {item.details.length > 0 && (
            <Chip
              label='FEFO disponible'
              size='small'
              sx={{ ...s.fefoChip, fontSize: '0.7rem' }}
              icon={<Box sx={s.fefoChipDot} />}
            />
          )}
          <Chip
            label={`Marca: ${item.brand}`}
            size='small'
            variant='outlined'
            sx={{ ...s.brandChip, fontSize: '0.7rem' }}
          />
        </Stack>
        <Stack alignItems='flex-end'>
          <Typography sx={{ ...s.quantityLabel, fontSize: '0.7rem' }}>Cantidad</Typography>
          <Typography sx={{ ...s.quantityValue, fontSize: '0.85rem' }}>{item.quantity}</Typography>
        </Stack>
      </Stack>

      {/* Toggle FEFO detail */}
      {hasBatches && (
        <>
          <Box onClick={() => setExpanded((p) => !p)} sx={s.fefoToggle}>
            <Typography sx={s.fefoToggleLabel}>
              {expanded ? 'Ocultar detalle FEFO' : 'Mostrar detalle FEFO'}
            </Typography>
          </Box>

          <Collapse in={expanded}>
            <Box sx={{ px: 1, pb: 1 }}>
              <Stack
                direction='row'
                justifyContent='space-between'
                sx={{ ...s.batchHeader, mb: 0.5 }}
              >
                {['Lote', 'Vencimiento', 'Cantidad'].map((h) => (
                  <Typography key={h} sx={{ ...s.batchHeaderText, fontSize: '0.7rem' }}>
                    {h}
                  </Typography>
                ))}
              </Stack>
              <Divider sx={{ my: 0.5 }} />
              <Stack spacing={0.25} mt={0.25}>
                {item.details.map((d) => {
                  const batchStatusColor = mapBatchStatusToExpiredColor(d.batchState)
                  const rowStyle = getStyleRow(batchStatusColor)
                  const expirationDate = formatExpirationDate(d.expires, 'dd-MM-yyyy')
                  return (
                    <Stack
                      key={d.batchNumber}
                      direction='row'
                      justifyContent='space-between'
                      alignItems='center'
                      sx={{
                        ...rowStyle,
                        p: 0.5,
                        borderRadius: '3px'
                      }}
                    >
                      <Typography sx={{ flex: 1, fontWeight: 500, fontSize: '0.75rem' }}>
                        {d.batchNumber}
                      </Typography>
                      <Typography sx={{ flex: 1, textAlign: 'center', fontWeight: 500, fontSize: '0.75rem' }}>
                        {expirationDate}
                      </Typography>
                      <Typography sx={{ flex: 1, textAlign: 'right', fontWeight: 500, fontSize: '0.75rem' }}>
                        {d.qty}
                      </Typography>
                    </Stack>
                  )
                })}
              </Stack>
            </Box>
          </Collapse>
        </>
      )}
    </Box>
  )
}
